/* ============================================================
   Radman custom scripts
   1. Homepage hero video (viewport-gated lazy load)
   2. Homepage logo slider (Slick carousel)
   ============================================================ */

/* ------------------------------------------------------------
   1. HERO VIDEO

   The homepage hero video is ~6.6 MB and custom.css hides it below
   861px. `display: none` does not stop an autoplaying <video> from
   downloading, so mobile visitors were paying the full 6.6 MB for
   something they never see.

   The markup now carries the URL in data-hero-video-src with
   preload="none" and no autoplay attribute. We attach the source and
   start playback only above the CSS breakpoint. The video is muted,
   so programmatic play() is allowed by browser autoplay policies.
   ------------------------------------------------------------ */
(function () {
  function initHeroVideo() {
    var videos = document.querySelectorAll('[data-hero-video]');

    Array.prototype.forEach.call(videos, function (video) {
      if (video.dataset.heroVideoLoaded) return;

      var minWidth = parseInt(video.dataset.heroVideoMinWidth, 10) || 861;
      if (window.innerWidth < minWidth) return;

      var src = video.dataset.heroVideoSrc;
      if (!src) return;

      var source = document.createElement('source');
      source.src = src;
      source.type = video.dataset.heroVideoType || 'video/mp4';
      video.appendChild(source);

      video.dataset.heroVideoLoaded = 'true';
      video.preload = 'auto';
      video.load();

      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') {
        // Autoplay can still be refused; the poster/background colour stands in.
        attempt.catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroVideo);
  } else {
    initHeroVideo();
  }

  // Handle a tablet rotating into desktop width after load.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initHeroVideo, 250);
  });
})();

/* ------------------------------------------------------------
   2. LOGO SLIDER
   Runs on the "Slick carousel (legacy)" layout of the Logo list
   section, which emits the .logo-slider class.
   ------------------------------------------------------------ */
$(document).ready(function () {
  var $slider = $('.logo-slider');

  if (!$slider.length || typeof $slider.slick !== 'function') return;

  $slider.slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
